import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, EventEmitter, input, linkedSignal } from "@angular/core";

import { SelfServiceCommandKeys } from "../../../helpers/enums/selfServiceCommands";
import { BgpPriority, StartLoadMessage } from "../../../helpers/self-service/models/types";
import { ModifyBgpCommand } from "../../../helpers/self-service/modify_bgp";
import { SelfServiceCommand } from "../../../helpers/self-service/self-service-command";
import { IpSubscriptionDetails } from "../../../pages/subscription-detail/types";
import { SelfserviceWizard } from "../selfservice-wizard/selfservice-wizard";
import { BgpSapRow } from "./bgp-sap-row";
import { BgpSapSummaryRow } from "./bgp-sap-summary-row";

@Component({
  selector: "selfservice-bgp",
  templateUrl: "selfservice-bgp.html",
  styleUrl: "selfservice-bgp.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, BgpSapRow, BgpSapSummaryRow, SelfserviceWizard, TranslatePipe],
})
export class SelfserviceBgp {
  protected subscription = input.required<IpSubscriptionDetails>();
  protected bus = input.required<EventEmitter<StartLoadMessage>>();

  protected sapsCopy = linkedSignal(() =>
    this.subscription().saps.map((sap) => ({ ...sap, initialBgpSessionPriority: sap.bgpSessionPriority })),
  );

  protected readonly buildCommand = () => {
    const action = SelfServiceCommandKeys.ModifyBgpPriority;
    const modify = new ModifyBgpCommand();
    this.sapsCopy()
      .filter((sap) => sap.bgpSessionPriority != null)
      .forEach((sap) => modify.setForInstance(sap.subscriptionInstanceId, sap.bgpSessionPriority as BgpPriority));
    const command = new SelfServiceCommand(this.subscription().subscriptionId, action);
    command.payload = modify;
    return { command, action };
  };
}
